import fetcher from 'features/shared/utils/fetcher'

async function getCheckTermsConditions(patientId:number) {
  return await fetcher.get('/check/terms-conditions/service/'+patientId)

}

export default getCheckTermsConditions
